import React from 'react';

import styled from 'styled-components';

var moment = require('moment-timezone');
const Balloon = styled.div`
position:relative;
    padding:0px;
    margin-top:15px;
`;
const Faceicon = styled.div`
    float: left;
        margin-right: -50px;
        width: 40px;
`;
const FaceiconImg = styled.img`
    width: 100%;
        height: auto;
        border-radius: 50%;
`;
const DisplayName = styled.div`
    margin:0 0 0 50px;
    font-size:9px;
    font-weight:bold;
    color:#FFF;
text-align:left;
`;
const Smsting = styled.div`
    width: 100%;
        text-align: left;
`;
const Say = styled.div`
    display: inline-block;
        position: relative; 
        margin: 0 0 0 50px;
        padding: 10px;
        max-width: 250px;
        border-radius: 12px;
        background: #edf1ee;
        margin-bottom: 2px;
    &:after{
        content: "";
        display: inline-block;
        position: absolute;
        top: 3px; 
        left: -19px;
        border: 8px solid transparent;
        border-right: 18px solid #edf1ee;
        -ms-transform: rotate(35deg);
        -webkit-transform: rotate(35deg);
        transform: rotate(35deg);
}
`;

const MsgArea = styled.p`
    margin: 0;
        padding: 0;
word-wrap: break-word;
`;
const Time = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 5px;
    position: absolute;bottom: 0px;
    font-size:10px;
    color:#FFF;
`;


// this.props.msg.message_text

export default class LineImgComponent extends React.Component {
    constructor(props) {
        super(props)
        const dt = new Date(this.props.msg.date)
        this.state = {
            date_time: (dt.getMonth() + 1) + "/" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes(),

        };

    }

    render() {
        if (this.props.msg.returnsms) {
            return (
                <Balloon className="col-xs-12" >
                    <Faceicon><FaceiconImg src={this.props.msg.img_url} /></Faceicon>
                    <DisplayName>{this.props.msg.display_name}</DisplayName>
                    <Smsting>
                        <Say>
                            <MsgArea>
                                <span dangerouslySetInnerHTML={{ __html: this.props.msg.returnsms.replace(/\r?\n/g, '<br/>') }} />
                            </MsgArea>
                        </Say>
                        {/* <Time>{moment.utc(this.props.msg.returnsmsdatetime).format('MM/DD HH:mm')}</Time> */}
                        <Time style={{ color: "#000000" }}>{moment.utc(this.props.msg.returnsmsdatetime, 'YYYY年MM月DD日 HH:mm:ss').format('MM/DD HH:mm')}</Time>
                    </Smsting>
                </Balloon>
            )
        } else {
            return ""
        }
    }
}
